// Re-export all boroughs.
import WestSussex from "./WestSussex";
import TowerHamlets from "./TowerHamlets";
import Haringey from "./Haringey";
import Essex from "./Essex";
import Lambeth from "./Lambeth";
import Oxfordshire from "./Oxfordshire";
import Lewisham from "./Lewisham";
import Barnet from "./Barnet";
import Cumbria from "./Cumbria";
import CountyDurham from "./CountyDurham";
import Barnsley from "./Barnsley";
import NorthAndNorthEastCumbria from "@/model/borough-data/NorthAndNorthEastCumbria";
import { DefaultHigh, DefaultHigher, DefaultIncreasing, DefaultLower, NullBanner } from "@/model/DefaultBanners";
import { RiskLevel } from "@/model/RiskLevel";
import Bradford from "@/model/borough-data/Bradford";
import Rotherham from "@/model/borough-data/Rotherham";
import Northumberland from "@/model/borough-data/Northumberland";
import Sheffield from "@/model/borough-data/Sheffield";
import Croydon from "@/model/borough-data/Croydon";
import Dudley from "@/model/borough-data/Dudley";
const Boroughs = [
    Barnet,
    Barnsley,
    Bradford,
    CountyDurham,
    Croydon,
    Cumbria,
    Dudley,
    Essex,
    Haringey,
    Lambeth,
    Lewisham,
    NorthAndNorthEastCumbria,
    Northumberland,
    Oxfordshire,
    Rotherham,
    Sheffield,
    TowerHamlets,
    WestSussex
].sort((a, b) => (a.name < b.name ? -1 : 1));
Boroughs.push({
    name: "Other",
    displayName: "&mdash; Other &mdash;",
    bannerInfo: {
        default: NullBanner,
        [RiskLevel.Lower]: DefaultLower,
        [RiskLevel.Increasing]: DefaultIncreasing,
        [RiskLevel.Higher]: DefaultHigher,
        [RiskLevel.High]: DefaultHigh
    }
});
export default Boroughs;
//# sourceMappingURL=index.js.map